var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLlamar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 13.5C15 15 15 16.5 13.5 16.5C12 16.5 10.5 15 9 13.5C7.5 12 6 10.5 6 9C6 7.5 7.5 7.5 9 6C10.5 4.5 6 0 4.5 0C3 0 0 4.5 0 4.5C0 7.5 3.0825 13.5825 6 16.5C8.9175 19.4175 15 22.5 18 22.5C18 22.5 22.5 19.5 22.5 18C22.5 16.5 18 12 16.5 13.5Z",
    fill: "#3BAF29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLlamar);
export default __webpack_public_path__ + "static/media/llamar.053bb3cdf518fff34f4e511f9abe800a.svg";
export { ForwardRef as ReactComponent };